export default "__VITE_ASSET__CQlFoEIT__"